import styled from 'styled-components'

const Container = styled.div`
  padding: 0 20px;
  width: 375px;
  margin: 0 auto;

  @media screen and (max-width: 576px) {
    width: auto;
  }
`

const TextBox = styled.div``

const IconBox = styled.div`
  margin-right: 10px;
`

const Title = styled.h1`
  font-weight: bold;
  color: var(--dark-blue);
  font-size: 24px;
  line-height: 110%;
  margin: 30px 0 10px 0 !important;
  width: auto;
`
const Description = styled.p`
  color: var(--orange);
  font-size: 19px;
  margin-bottom: 15px !important;
`

const Group = styled.div`
  padding: 30px;
  background: #f6f6f6;
  width: auto;
  height: 153px;
  display: flex;
  border-radius: 5px;
  text-align: left;
`

const Button = styled.a`
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  background: #f2662e;
  color: #fff;
  border-radius: 20px;
  margin-top: 25px;
  padding: 0;
  text-decoration: none;
  background: var(--orange);
  border: 1px solid var(--orange);
  color: #fff;

  &:hover {
    background: #fff;
    color: var(--orange);
    text-align: center;
  }

  &:active {
    background: rgba(242, 102, 46, 0.2);
    color: var(--orange);
    text-align: center;
  }
`

export { Container, Group, TextBox, IconBox, Button, Title, Description }
